// src/components/TypeCards.js (Corrected)

import { useTheme } from "@emotion/react";
import { Card, CardActionArea, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

const TypeCards = ({ month, selectedCard, setSelectedCard }) => {
  const theme = useTheme();
  const baseDate = dayjs(month);

  const cards = [
    {
      title: `${baseDate.format("MMMM YYYY")}`,
      date: `${baseDate.startOf("month").format("YYYY-MM-DD")}`,
      type: "current",
      color: theme.palette.primary.main,
    },
    {
      title: `Forecast : ${baseDate.add(1, "month").format("MMMM YYYY")}`,
      date: `${baseDate.add(1, "month").startOf("month").format("YYYY-MM-DD")}`,
      type: "forecast 1",
      color: theme.palette.warning.main,
    },
    {
      title: `Forecast : ${baseDate.add(2, "month").format("MMMM YYYY")}`,
      date: `${baseDate.add(2, "month").startOf("month").format("YYYY-MM-DD")}`,
      type: "forecast 2",
      color: theme.palette.error.main,
    },
  ];

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="center"
      sx={{ flexWrap: "wrap" }}
    >
      {cards.map((card, index) => (
        <CardActionArea
          key={index}
          sx={{
            width: 250,
            height: 50,
            borderRadius: 2,
          }}
          // --- CHANGE 1: Update the state with the full card OBJECT ---
          onClick={() => {
            setSelectedCard(card);
          }}
        >
          <Card
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 2,
              borderRadius: "inherit",
              // --- CHANGE 2: Compare the .title property of the OBJECT ---
              // Use optional chaining (?.) for safety.
              border: `2px solid ${
                selectedCard?.type === card.type ? card.color : "transparent"
              }`,
            }}
          >
            <Typography variant="body1">{card.title}</Typography>
          </Card>
        </CardActionArea>
      ))}
    </Stack>
  );
};

export default TypeCards;
